import { render, staticRenderFns } from "./SubjectAgg.vue?vue&type=template&id=e6a5c978&scoped=true&"
import script from "./SubjectAgg.vue?vue&type=script&lang=js&"
export * from "./SubjectAgg.vue?vue&type=script&lang=js&"
import style0 from "./SubjectAgg.vue?vue&type=style&index=0&id=e6a5c978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a5c978",
  null
  
)

export default component.exports